import { Swiper as SwiperContent, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/free-mode'
import 'swiper/css/scrollbar'

import { definePlugin } from '/@/app'

export default definePlugin(({ app }) => {
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('SwiperContent', SwiperContent)
  app.component('SwiperSlide', SwiperSlide)
})
